import { render, staticRenderFns } from "./OfertaFormFields.vue?vue&type=template&id=cccc5976&scoped=true&"
import script from "./OfertaFormFields.vue?vue&type=script&lang=js&"
export * from "./OfertaFormFields.vue?vue&type=script&lang=js&"
import style0 from "./OfertaFormFields.vue?vue&type=style&index=0&id=cccc5976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccc5976",
  null
  
)

export default component.exports